import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { useStore } from "../../store";

export default function DroneLabel() {
  const map           = useMap();
  const drones        = useStore(s => s.drones);
  const alarmedDrones = useStore(s => s.alarmedDrones);
  const ref           = useRef<Map<string, L.Marker>>(new Map());

  useEffect(() => {
    const cur = ref.current;

    // Add/update labels only for alarmed drones
    alarmedDrones.forEach((_status: any, id: string) => {
      const drone: any = drones.get(id);
      if (!drone || drone.lat == null || drone.lng == null) return;
      const lat = Number(drone.lat), lng = Number(drone.lng);
      const alt = drone.altitudeM   != null ? Math.round(drone.altitudeM)   + "m" : "—";
      const dir = drone.directionDeg != null ? Math.round(drone.directionDeg) + "°" : "—";
      const html = `<div class="drone-lbl"><b>${alt}</b><span>${dir}</span></div>`;
      const icon = L.divIcon({ html, className: "", iconSize: [54, 22], iconAnchor: [-12, 11] });
      const ex = cur.get(id);
      if (ex) { ex.setLatLng([lat, lng]); ex.setIcon(icon); }
      else { cur.set(id, L.marker([lat, lng], { icon, interactive: false, zIndexOffset: -100 }).addTo(map)); }
    });

    // Remove labels for drones no longer alarmed
    cur.forEach((m, id) => {
      if (!alarmedDrones.has(id)) { m.remove(); cur.delete(id); }
    });
  }, [alarmedDrones, drones, map]);

  useEffect(() => () => { ref.current.forEach(m => m.remove()); ref.current.clear(); }, []);
  return null;
}
